import { importHtml } from "./common/dev";
import { generateShades } from "@common/utils/initUtils";
function getOriginalColorSet() {
  const colorSet: any = {
    type: "GET_color",
    init: window.location.href.includes("indexValue"),
    theme: undefined,
    point: undefined,
    background: undefined,
  };
  const themeColor = $("html body").css("--themeColor");
  const pointColor = $("html body").css("--pointColor");
  const backgroundColor = $("html body").css("--bgthemeColor");
  colorSet.theme = themeColor;
  colorSet.point = pointColor;
  colorSet.background = backgroundColor;
  const colors = generateShades({
    themeColor,
  });
  const { darker, lighter } = colors.themeColor;
  darker.forEach((color, idx) => {
    $("html body").css(`--themeColor-dark-${idx + 1}`, color);
  });
  lighter.forEach((color, idx) => {
    $("html body").css(`--themeColor-light-${idx + 1}`, color);
  });
  return colorSet;
}
function setTheMe(Color: any) {
  const { theme, point, background } = Color;
  $("html body").css("--themeColor", theme);
  $("html body").css("--pointColor", point);
  $("html body").css("--bgthemeColor", background);
  const colors = generateShades({
    themeColor: theme,
  });
  const { darker, lighter } = colors.themeColor;
  darker.forEach((color, idx) => {
    $("html body").css(`--themeColor-dark-${idx + 1}`, color);
  });
  lighter.forEach((color, idx) => {
    $("html body").css(`--themeColor-dark-${idx + 1}`, color);
  });
}
export async function init() {
  /* Dev Start */
  await importHtml();
  /* Dev End */

  window.parent.postMessage(getOriginalColorSet(), "*");
  window.parent.postMessage({ type: "linkChange", href: window.location.href }, "*");
  $("a").not('[rel="nofollow"]').attr("href", "javascript:;");
  window.addEventListener("message", function ({ data }) {
    if (data && data.type && data.type === "SET_color") {
      setTheMe(data);
    }
  });
}
